import { render, staticRenderFns } from "./MarginSpread.vue?vue&type=template&id=5ddad555&scoped=true"
import script from "./MarginSpread.vue?vue&type=script&lang=js"
export * from "./MarginSpread.vue?vue&type=script&lang=js"
import style0 from "./MarginSpread.vue?vue&type=style&index=0&id=5ddad555&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddad555",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
